import React from 'react';
import { Link, Title } from '../';

import Logo from './Logo';

const ListItemHeader = ({ slug, logoImage, humanName, heading }: any) => {
  const sharpImage = logoImage && logoImage.childImageSharp;

  return (
    <Link to={slug} className="underline-none capitalize">
      <Logo sharpImage={sharpImage} alt={`${humanName} logo`} />
      <div className="pb-4">
        <Title>{humanName}</Title>
        <small>{heading}</small>
      </div>
    </Link>
  );
};

export default ListItemHeader;
